import React, { useEffect, useState, useContext } from 'react';
import { UserOrderContext } from 'context/context';
import {
  isMobileDevice,
  getPrice,
  getLength,
  isEmptyObject,
  getValueByKeyName,
  jsontoObjects,
  getAndCheck,
  getValueOrDefaultObject,
  getTernaryValue,
  checkAllTrue,
  getAndCheckIfOneTrue,
} from 'common/utilities/utils';
import { useSelector } from 'react-redux';
import { CART_PAGE_CONSTANTS } from 'organisms/CartPage/Constants/CartPageConstants';
import ModifierCardComponent from 'molecules/ModifierCard/AU/Container/ModifierCardComponent';
import PRODUCT_CONSTANTS from 'organisms/ProductListingModalOptions/AU/Constants/ProductListingModalOptionsConstants';
import { MENU_PDP_PAGE_CONSTANTS } from 'organisms/MenuPDPPage/AU/Constants/MenuPDPPageConstants';
import { priceFixed_value, priceRoundoff_value, IMAGE_SIZE_CONSTANTS, RESIZE } from 'common/constants/SharedConstants';

const checkDefaultReason = (modifiers, DEFAULT_REASON, RECIPE) => {
  return modifiers.every(ele => getValueByKeyName(ele.additionalProperties, DEFAULT_REASON) === RECIPE);
};

export const getRenderCheckBox = (modifiers, additionalProperties, modGMax) => {
  const { RECIPE, DEFAULT_REASON, MODGROUP_MAX_RADIOBUTTON } = MENU_PDP_PAGE_CONSTANTS;
  return (
    checkDefaultReason(modifiers, DEFAULT_REASON, RECIPE) ||
    !getRenderQuantityModifier(additionalProperties) ||
    modGMax === MODGROUP_MAX_RADIOBUTTON
  );
};

const getQuantityToDisplay = (flag, QUANTITY_ACTION, quantityUpdated, defaultQuantityDisplay) => {
  return getAndCheckIfOneTrue(flag === QUANTITY_ACTION.Increase, flag === QUANTITY_ACTION.Decrease)
    ? quantityUpdated
    : defaultQuantityDisplay;
};

export const getRenderQuantityModifier = additionalProperties => {
  const { PEROPTIONMAX_KEY, PEROPTIONMIN_KEY, MAXDISTINCT_KEY } = MENU_PDP_PAGE_CONSTANTS;
  let additionalObj = jsontoObjects(additionalProperties);
  let props = [PEROPTIONMAX_KEY, PEROPTIONMIN_KEY, MAXDISTINCT_KEY];
  return (
    props.every(prop => Object.prototype.hasOwnProperty.call(additionalObj, prop)) &&
    !(
      additionalObj[PEROPTIONMAX_KEY] === 0 &&
      additionalObj[PEROPTIONMIN_KEY] === 0 &&
      additionalObj[MAXDISTINCT_KEY] === 0
    )
  );
};

const ProductCustomizeToppingComp = ({ tenantData, modifiers, modgrpData, isModal, isStoreClosed, catalog }) => {
  const [isMobile, setMobileHeader] = useState(isMobileDevice(window.innerWidth));
  const { modgrpId, additionalProperties, max: modGMax } = modgrpData;
  const [savedCustomizedModifier, setSavedCustomizedModifier] = useState({});
  const { userOrderState } = useContext(UserOrderContext);
  const { resetCustomization } = userOrderState;
  let userParams = useSelector(data => data.appStateReducer.userStatus);
  const cartReducerData = useSelector(data => data.cartReducer);
  const { isItemAdded = false } = getValueOrDefaultObject(cartReducerData);
  const [renderQtyModifier, setRenderQtyModifier] = useState();
  const [renderCheckbox, setRenderCheckbox] = useState();
  const [updatedItemIds, setUpdatedItemIds] = useState([]);
  const [savedModifiers, setSavedModifiers] = useState([]);
  const [initialRender, setInitialRender] = useState(true);
  const [imageContainerWidth, setImageContainerWidth] = useState(0);
  const { SINGLE } = PRODUCT_CONSTANTS;
  const { PDP_MODIFIER } = IMAGE_SIZE_CONSTANTS;

  useEffect(() => {
    setSavedCustomizedModifier({});
    setUpdatedItemIds([]);
    setSavedModifiers([]);
    setInitialRender(true);
  }, [resetCustomization]);

  useEffect(() => {
    if (!isModal) {
      setSavedCustomizedModifier({});
      setUpdatedItemIds([]);
      setSavedModifiers([]);
      setInitialRender(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [catalog, isItemAdded]);

  useEffect(() => {
    if (getAndCheck(isEmptyObject(additionalProperties), getLength(modifiers))) {
      let shouldRenderCheckBox = getRenderCheckBox(modifiers, additionalProperties, modGMax);
      setRenderCheckbox(shouldRenderCheckBox);
      let additionalData = !shouldRenderCheckBox && getRenderQuantityModifier(additionalProperties);
      setRenderQtyModifier(additionalData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [additionalProperties, modifiers]);
  const windowResized = () => {
    const isMobileView = isMobileDevice(window.innerWidth);
    const imageWidth = isMobileView
      ? PDP_MODIFIER.PDP_MODF_IMAGE_VIEWPORT_WIDTH_MOBILE
      : PDP_MODIFIER.PDP_MODF_IMAGE_VIEWPORT_WIDTH_DESKTOP;
    const containerWidth = Math.round((imageWidth * window.innerWidth) / priceRoundoff_value);
    setImageContainerWidth(containerWidth);
    setMobileHeader(isMobileView);
  };
  useEffect(() => {
    window.addEventListener(RESIZE, windowResized);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobile]);
  useEffect(() => {
    windowResized();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const { QUANTITY_ACTION } = CART_PAGE_CONSTANTS;

  const savedModifierHandler = (cardData, flag, savedModifiersInfo, onClick = false) => {
    let { id } = cardData;
    if (flag === SINGLE) {
      //on user check when min=max=1
      modifiers.forEach(item => {
        if (item.id === id) {
          setUpdatedItemIds([item.id]);
        }
      });
      setSavedModifiers([{ ...cardData, itemId: id, modgrpId }]);
    } else if (flag) {
      //for default and on user check
      let checkIfExists = savedModifiersInfo.some(({ id }) => id === cardData.id);
      if (!checkIfExists) {
        let modifierListData = [...savedModifiersInfo, { ...cardData, itemId: id, modgrpId }];
        let updateditemsData = modifierListData?.map(item => item?.id);
        onClick && setUpdatedItemIds(updateditemsData);
        setSavedModifiers(modifierListData);
      }
    } else if (savedModifiersInfo.length) {
      //on user uncheck
      let modifiersToUpdateData = savedModifiersInfo.filter(({ itemId }) => itemId !== id);
      let updateditemsData = modifiersToUpdateData?.map(item => item?.id);
      setUpdatedItemIds(updateditemsData);
      setSavedModifiers(modifiersToUpdateData);
    }
  };

  const saveCustomizedItemCount = (id, modgrp_id, flag, defaultQuantity, defaultQuantityDisplay) => {
    let itemFound = savedCustomizedModifier?.[modgrp_id]?.[id];
    let item = savedCustomizedModifier?.[modgrp_id];
    let totalQuantity = savedCustomizedModifier?.totalQuantity;
    if (!itemFound) {
      if (isEmptyObject(savedCustomizedModifier[modgrp_id])) {
        setSavedCustomizedModifier({
          ...savedCustomizedModifier,
          totalQuantity: totalQuantity + defaultQuantity,
          [modgrp_id]: { ...item, [id]: { quantity: defaultQuantity, quantityDisplay: defaultQuantity } },
        });
      } else {
        setSavedCustomizedModifier({
          totalQuantity: defaultQuantity,
          [modgrp_id]: { [id]: { quantity: defaultQuantity, quantityDisplay: defaultQuantity } },
        });
      }
    } else {
      let quantityUpdated =
        flag === QUANTITY_ACTION.Increase
          ? item[id].quantity + 1
          : getTernaryValue(flag === QUANTITY_ACTION.Decrease, item[id].quantity - 1, defaultQuantity);
      let totalQuantityUpdated =
        flag === QUANTITY_ACTION.Increase
          ? totalQuantity + 1
          : getTernaryValue(
              flag === QUANTITY_ACTION.Decrease,
              totalQuantity - 1,
              totalQuantity - item[id].quantity + defaultQuantity,
            );
      let quantityToDisplay = getQuantityToDisplay(flag, QUANTITY_ACTION, quantityUpdated, defaultQuantityDisplay);
      setSavedCustomizedModifier({
        ...savedCustomizedModifier,
        totalQuantity: totalQuantityUpdated,
        [modgrp_id]: { ...item, [id]: { ...item[id], quantity: quantityUpdated, quantityDisplay: quantityToDisplay } },
      });
    }
  };

  return (
    checkAllTrue([renderCheckbox !== undefined, renderQtyModifier !== undefined, !!imageContainerWidth]) &&
    modifiers.map((modF, idx) => {
      let price = getPrice(modF.availability[0], tenantData?.currencyConversionFactor).toFixed(priceFixed_value);

      return (
        <ModifierCardComponent
          tenantData={tenantData}
          modgrpData={modgrpData}
          cardData={modF}
          price={price}
          isMobile={isMobile}
          localized={userParams.localized}
          currencySymbol={tenantData?.currencySymbol}
          saveCustomizedItemCount={saveCustomizedItemCount}
          savedCustomizedModifier={savedCustomizedModifier}
          toRenderCheckBox={renderCheckbox}
          toRenderQuantityModifier={renderQtyModifier}
          savedModifierHandler={savedModifierHandler}
          updatedItems={updatedItemIds}
          savedModifiers={savedModifiers}
          isModal={isModal}
          isStoreClosed={isStoreClosed}
          initialRender={initialRender}
          setInitialRender={setInitialRender}
          catalog={catalog}
          imageContainerSize={imageContainerWidth}
        />
      );
    })
  );
};

export default ProductCustomizeToppingComp;
